import { useState, useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// @mui material components
// Material Kit 2 PRO React components
import MKBox from "../../components/MKBox";
import InputLabel from "@mui/material/InputLabel";
// Image
import PageLayout from "../../layouts/dashboards";
import AuthenticationCardLayout from "../../layouts/AuthenticationCard/AuthenticationCardLayout";
import { useSelector } from "react-redux";
import ChangePasswordSection from "../../pageSections/ChangePassword";
function Page() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state) => state.user);

  const [inputs, setInputs] = useState({
    user_name: "",
    isAuthenticated: true,
  });

  /* #region  Get Location Data - Email Information */
  useEffect(() => {
    const getLocationData = async () => {
      const locationData = await location.state;

      if (locationData !== null) {
        setInputs({
          ...inputs,
          user_name: locationData.email,
          isAuthenticated: locationData?.isAuthenticated ?? true,
        });
      }
    };
    getLocationData();
  }, []);
  /* #endregion */

  return (
    <>
      <PageLayout isAuthenticated={inputs.isAuthenticated}>
        <AuthenticationCardLayout
          title="Change Password"
          subtitle={
            inputs.isNoAuthPage === true
              ? "As you're logging in for the first time, you are required to change your password"
              : ""
          }
          loading={isLoading}
        >
          <ChangePasswordSection />
        </AuthenticationCardLayout>
      </PageLayout>
    </>
  );
}

export default Page;
